/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Constants from './Config/Config';
import classNames from 'classnames';
import MainMenuItems from './Components/Menu/MainMenuItems';

class Header extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
			mainMenu: [
				{
					"ID": 162,
					"url": "https://www.justpictureframingonline.com.au/",
					"title": "Home",
				},
				{
					"ID": 425,
					"url": "https://www.justpictureframingonline.com.au/picture-framing/",
					"title": "Products",
				},
				{
					"ID": 165,
					"url": "https://www.justpictureframingonline.com.au/interior-designer-tips/",
					"title": "Interior Designer Tips",
				},
				{
					"ID": 166,
					"url": "https://www.justpictureframingonline.com.au/postage-handling/",
					"title": "Postage & Handling",
				},
				{
					"ID": 168,
					"url": "https://www.justpictureframingonline.com.au/about-us/",
					"title": "About Us",
				},
				{
					"ID": 169,
					"url": "https://www.justpictureframingonline.com.au/faq/",
					"title": "FAQ",
				},
				{
					"ID": 170,
					"url": "https://www.justpictureframingonline.com.au/contact/",
					"title": "Contact",
				}
			],
			isToggleOn: false
	    }
	    this.mobileMenu = [
	    	...this.state.mainMenu,
	    	{
	    		"ID": 999,
	    		"url": "https://www.justpictureframingonline.com.au/my-account/",
	    		"title": "Login / Register",
	    	}
	    ];
	    this.onMenuClick = this.onMenuClick.bind(this);
  	}

  	onMenuClick() {
	    this.setState(prevState => ({
      		isToggleOn: !prevState.isToggleOn
   	 	}));
  	}

  	render() {
  		const { mainMenu } = this.state;
  		const classes = classNames({
	        'cd-dropdown': true, // we always want this class
	        'dropdown-is-active': this.state.isToggleOn, // only add this class if the state says so
     	});
	    return (
			<div className="sticky-menu">
				<div className="top_hed full_width" ref={element => this.divRef = element}>
					<div className="container">
						<div className="header-wrapper">
							<div className="logo">
								<a href={Constants.URL.root} className="custom-logo-link">
									<img src={Constants.URL.ImageURL+"/logo.png"} alt={Constants.SITE_TITLE} />
								</a>
								<a href={Constants.URL.root} className="showSticky">
									<img src={Constants.URL.ImageURL+"/white-logo.png"} alt={Constants.SITE_TITLE} />
								</a>
							</div>
							<div className="top_rgt_cont color_blck">
								<div className="menu right">
									<MainMenuItems
										mainMenu={mainMenu} />
								</div>
								<div className="menu_avt">
									<a href={Constants.URL.root+"/my-account"}>
										<img src={Constants.URL.ImageURL+"/man_avtar.png"} alt="My Account" />
									</a>
								</div>
								<div className="cart">
									<i><img src={Constants.URL.ImageURL+"/cart.png"} alt="Cart" /></i>
									<a href={Constants.URL.root+"/cart"}>cart <span> ({this.props.cartQty} items)</span></a>
								</div>
							</div>
						</div>
					</div>
					<div className="cd-dropdown-wrapper">
						<a className="cd-dropdown-trigger meanmenu-reveal" href="#!" onClick={this.onMenuClick}><span></span><span></span><span></span></a>
						<nav className={classes}>
							<h2>Menu</h2>
							<a href="#!" onClick={this.onMenuClick} className="cd-close">Close</a>
					<MainMenuItems
							mainMenu={this.mobileMenu}
							classNameUL={"cd-dropdown-content"} />
						</nav>
					</div>
				</div>
			</div>
	    );
  	}
}

export default Header;